<form class="verification-code" autocomplete="off" aria-autocomplete="none" novalidate>
  <input
    *ngFor="let code of verificationCodeForm.controls; index as index"
    class="verification-code_field"
    [ngClass]="{
      'verification-code_field--invalid': code.touched && code.invalid
    }"
    [name]="'verification-code-' + index"
    type="number"
    (keydown)="onKeyDown($event, index)"
    autocomplete="off"
    maxlength="6"
    [formControl]="code"
  />
</form>
